import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useToast } from "@/components/ui/use-toast";
import { FileCheck, Shield, AlertTriangle, Brain } from "lucide-react";
import IDVerification from "@/pages/admin/verification/IDVerification";
import DocumentAnalysis from "@/pages/admin/verification/DocumentAnalysis";
import FraudDetection from "@/pages/admin/verification/FraudDetection";
import ReviewVerifications from "@/pages/admin/verification/ReviewVerifications";

const VerificationManagement = () => {
  const { toast } = useToast();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Verification Management</h1>
        <Shield className="h-8 w-8 text-primary" />
      </div>

      <Card className="p-6">
        <Tabs defaultValue="id-verification" className="space-y-4">
          <TabsList className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <TabsTrigger value="id-verification" className="flex items-center gap-2">
              <FileCheck className="h-4 w-4" />
              ID Verification
            </TabsTrigger>
            <TabsTrigger value="document-analysis" className="flex items-center gap-2">
              <Brain className="h-4 w-4" />
              Document Analysis
            </TabsTrigger>
            <TabsTrigger value="fraud-detection" className="flex items-center gap-2">
              <AlertTriangle className="h-4 w-4" />
              Fraud Detection
            </TabsTrigger>
            <TabsTrigger value="review" className="flex items-center gap-2">
              <Shield className="h-4 w-4" />
              Review Verifications
            </TabsTrigger>
          </TabsList>

          <TabsContent value="id-verification">
            <IDVerification />
          </TabsContent>

          <TabsContent value="document-analysis">
            <DocumentAnalysis />
          </TabsContent>

          <TabsContent value="fraud-detection">
            <FraudDetection />
          </TabsContent>

          <TabsContent value="review">
            <ReviewVerifications />
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  );
};

export default VerificationManagement;